import { useMemo } from 'react';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import type { SupportedThirdParty } from '../../../common/constants/import-type';
import { type SupportedTool, type Tool, getTools } from '../../../common/constants/tools';
import { useProjectData } from '../../import-state';

const EMPTY_SUPPORTED_TOOLS: Tool[] = [];
const EMPTY_UNAVAILABLE_TOOLS: Tool[] = [];

export const useTools = () => {
	const [{ type }] = useProjectData();
	const { isSiteAdmin } = useTenantContext();

	const [supportedTools, unavailableTools]: [Tool[], Tool[]] = useMemo(() => {
		const tools = getTools(type, isSiteAdmin);
		return tools.reduce(
			([supported, unavailable], tool: Tool) =>
				tool.isSupported
					? [[...supported, tool], unavailable]
					: [supported, [...unavailable, tool]],
			[EMPTY_SUPPORTED_TOOLS, EMPTY_UNAVAILABLE_TOOLS],
		);
	}, [isSiteAdmin, type]);
	return {
		supportedTools,
		unavailableTools,
	};
};

export const useImportTool = (key: SupportedThirdParty): SupportedTool | undefined => {
	const [{ type }] = useProjectData();
	const { isSiteAdmin } = useTenantContext();
	return useMemo(() => {
		const result = getTools(type, isSiteAdmin).find((tool) => tool.key === key);
		return result && result.isSupported ? result : undefined;
	}, [isSiteAdmin, key, type]);
};
